export default "__VITE_ASSET__D6pQhH3l__"